import { CrudService, EntityProps } from '@awp/shared/CrudService';
import React from 'react';
import { FORM_MODE } from '@awp/constants';

export default class VmsService extends CrudService {
  constructor(mode: string) {
    const entityName = 'Variable Message Sign';
    const entityPluralName = 'Variable Message Signs';

    super({ entityName, entityPluralName, mode });
  }

  getActionMenu(event: any): React.ReactElement {
    return <></>;
  }

  getColumns(props: any): any {
    /* Do Nothing */
  }

  getFields(props: any): React.ReactElement {
    return <></>;
  }

  getValidations(props?: any): any {
    /* Do Nothing */
  }

  mapFormToDTO(props: any): any {
    /* Do Nothing */
  }

  mapInitialValues(props: any): any {
    const { entity, mode, ...rest } = props;

    return {
      name: entity.Name ?? '',
      stateKey: entity.StateKey ?? '',
      weatherStation:
        entity && entity.WeatherStationId > 0
          ? {
              value: entity.WeatherStationId,
              label: entity.WeatherStationNumber + ' - ' + entity.WeatherStationName,
            }
          : null,
      sensorPlacement:
        entity && entity.SensorPlacementId > 0
          ? {
              value: entity.SensorPlacementId,
              label: entity.SensorPlacementName,
            }
          : null,
      location: entity.Location,
      isActive: mode === FORM_MODE.CREATE || entity.IsActive === 'Y',
      description: entity.Description ?? '',
    };
  }

  cleanFormValues(props: EntityProps): any {
    /* Do Nothing */
  }
}
